export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6331.ee5d5ecf.jpg";